import { useReducedMotion } from 'framer-motion';

/**
 * Reactive hook for motion preferences.
 * Wraps framer-motion's useReducedMotion with helpers for variants/transitions.
 */
export function useMotionPreferences() {
  const shouldReduceMotion = useReducedMotion() ?? false;

  return { shouldReduceMotion };
}
